const configuredEnvironment = window["environment"];
if (!configuredEnvironment) {
  throw new Error("Failed to load environment configuration from server.");
}

export const environment = Object.assign({
  apiUrl: '/capweb/api',
  production: true,
  kanton: 'BI',
  openIdConnect: {
    issuer: 'https://localhost:8080/auth/realms/capitastra',
    clientId: 'capitastra-client',
    noSSL: false,
    idpHint: undefined,
    postLogoutRedirectUri: undefined,
  },
  clientLevel: 'all',
  serverLevel: 'all',
  bbvEnabled: false
}, configuredEnvironment); // durch assets/environment.js gesetzt
